import { Anchor } from "@omni/ui/components/Anchor/anchor.component";
import { cn } from "@omni/utils/styles";

import { useProductComparisonBarContext } from "@/components/Product/ProductComparisonBar/context/productComparisonBar.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import * as ComparisonCompareTracker from "@/services/tracking/trackers/feature/comparisonCompare.tracker";
import { Config } from "@/utils/config.utils";

type Props = {
    className?: string;
};

export const CompareButton = ({ className }: Props) => {
    const { t } = useGranite();

    const { products } = useProductComparisonBarContext();

    const skus = products.map((product) => product.sku);

    const href = `${Config.pages.compare}?products=${skus.join(",")}`;

    const handleOnClick = () => {
        ComparisonCompareTracker.trackProducts(products);
    };

    return (
        <div className={cn("tw:w-full tw:px-4 tw:pb-4")}>
            <Anchor
                href={href}
                className={className}
                fullWidth={true}
                onClick={handleOnClick}
            >
                {t("productComparison.compareProducts", products.length)}
            </Anchor>
        </div>
    );
};
